module.exports = __webpack_public_path__ + "img/avatar3.a94cbb08.png";